// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2019":"275280d7","4141":"275280d7","7106":"ce053872","9236":"8ecf045c","9489":"2b7c1a87"}[chunkId] + ".chunk.css";
};